import React from 'react';
import IconNoSearchResults from '../../../shared/icons/icon-no-search-results.svg';


const EmptySearchResults = function EmptySearchResultsComponent() {
  return (
    <div className="results-grid__results--empty">
      <div className="results-grid__results-image--empty">
        <IconNoSearchResults className="results-grid__no-results-icon" />
      </div>
      <p className="results-grid__results-text--empty">
        No results found for your search – update your search and try again.
      </p>
    </div>
  );
};

export default EmptySearchResults;
